/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ timecode: NonNullable<unknown> }} Video_Export_Status_ExportingInputs */

const en_video_export_status_exporting = /** @type {(inputs: Video_Export_Status_ExportingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exporting: ${i?.timecode} done`)
};

const fr_video_export_status_exporting = /** @type {(inputs: Video_Export_Status_ExportingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exportation : ${i?.timecode} terminee`)
};

const de_video_export_status_exporting = /** @type {(inputs: Video_Export_Status_ExportingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exportieren: ${i?.timecode} abgeschlossen`)
};

const it_video_export_status_exporting = /** @type {(inputs: Video_Export_Status_ExportingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Esportazione: ${i?.timecode} completata`)
};

const ru_video_export_status_exporting = /** @type {(inputs: Video_Export_Status_ExportingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Экспорт: ${i?.timecode} завершен`)
};

const es_video_export_status_exporting = /** @type {(inputs: Video_Export_Status_ExportingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exportando: ${i?.timecode} hecho`)
};

const zh_cn2_video_export_status_exporting = /** @type {(inputs: Video_Export_Status_ExportingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`导出完成：${i?.timecode}`)
};

const ja_video_export_status_exporting = /** @type {(inputs: Video_Export_Status_ExportingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`エクスポート中: ${i?.timecode} 完了`)
};

const hi_video_export_status_exporting = /** @type {(inputs: Video_Export_Status_ExportingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`निर्यात हो रहा है: ${i?.timecode} पूरा हुआ`)
};

const pt_pt2_video_export_status_exporting = /** @type {(inputs: Video_Export_Status_ExportingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exportando: ${i?.timecode} concluído`)
};

/**
* | output |
* | --- |
* | "Exporting: {timecode} done" |
*
* @param {Video_Export_Status_ExportingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_status_exporting = /** @type {((inputs: Video_Export_Status_ExportingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Status_ExportingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_status_exporting(inputs)
	if (locale === "de") return de_video_export_status_exporting(inputs)
	if (locale === "it") return it_video_export_status_exporting(inputs)
	if (locale === "ru") return ru_video_export_status_exporting(inputs)
	if (locale === "es") return es_video_export_status_exporting(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_status_exporting(inputs)
	if (locale === "ja") return ja_video_export_status_exporting(inputs)
	if (locale === "hi") return hi_video_export_status_exporting(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_status_exporting(inputs)
	return en_video_export_status_exporting(inputs)
});